import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { navItems } from "./../../_nav";
import { Router, NavigationEnd, ActivatedRoute, Event } from "@angular/router";
import { filter } from "rxjs/operators";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { ToasterConfig } from "angular2-toaster";
import { ICAreaService } from "../../services/icarea.service";
import { ICArea } from "../../models/entities/icarea";
import { ICMenuService } from "../../services/icmenu.service";
import { ICUserService } from "../../services/icuser.service";
import { ICMenuFilter } from "../../models/filters/icmenu.filter";
import { ICMenuApi } from "../../models/apis/icmenu.api";

@Component({
  selector: "app-dashboard",
  templateUrl: "./default-layout.component.html",
  providers: [ICMenuService],
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  public showAreaSelector = true;
  public MaxLevel: number = null;
  public IsChrome = true;
  public Locked = true;
  public LoadAll = false;

  CurrentLogo = "assets/img/brand/logo.png";

  year = new Date().getFullYear();
  areaBreadcrumbs = "";
  translated = false;
  SaveFilter = false;

  breadcrumbs: Observable<Array<Object>>;
  private _breadcrumbs: BehaviorSubject<Array<Object>>;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  areaSubscription: Subscription;

  mapMenu(menu: ICMenuApi) {
    const menuItem: any = {};
    if (menu.Name) {
      menuItem.name = menu.Name;
    }
    if (menu.Url) {
      menuItem.url = menu.Url;
    }
    if (menu.Icon) {
      menuItem.icon = menu.Icon;
    }
    if (menu.Title) {
      menuItem.title = menu.Title;
    }
    if (menu.ChildrensApi && menu.ChildrensApi.length > 0) {
      menuItem.children = menu.ChildrensApi.sort(
        (a, b) => a.Order - b.Order,
      ).map((t) => this.mapMenu(t));
    }
    return menuItem;
  }

  constructor(
    private translateSrv: TranslateService,
    private areaSrv: ICAreaService,
    private router: Router,
    private userSrv: ICUserService,
    private menuSrv: ICMenuService,
    private route: ActivatedRoute,
  ) {
    // this.translate(this.navItems);

    this.userSrv.current().then((user) => {
      if (user) {
        this.menuSrv.list(new ICMenuFilter({ UserId: user.Id })).then((r) => {
          const tmpList = r.ListResult.sort((a, b) => a.Order - b.Order).map(
            (t) => this.mapMenu(t),
          );
          for (let i = 0; i < tmpList.length; i++) {
            if (
              tmpList[i].title &&
              (i + 1 >= tmpList.length ||
                (i + 1 < tmpList.length && tmpList[i + 1].title))
            ) {
              tmpList.splice(i, 1);
              i--;
            }
          }
          this.navItems = tmpList;
          this.translate(this.navItems);
        });
      } else {
        location.href = location.origin;
      }
    });

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized =
        document.body.classList.contains("sidebar-minimized");
    });

    areaSrv.current().then((area: ICArea) => {
      this.createAreaBreads(area);
    });

    this.changes.observe(<Element>this.element, {
      attributes: true,
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.IsChrome =
          (<any>window).chrome &&
          ((<any>window).chrome.runtime || (<any>window).chrome.app);

        const analyticZone = event.urlAfterRedirects.indexOf("analytics") > -1;
        const digitalSineageZone =
          event.urlAfterRedirects.indexOf("media") > -1;
        const controlRoomZone = event.urlAfterRedirects.indexOf("control") > -1;
        const userAreaList =
          event.urlAfterRedirects.indexOf("settings/users/list") > -1;
        const userAreaSingle =
          event.urlAfterRedirects.indexOf("settings/users/single") > -1;
        const deviceArea =
          event.urlAfterRedirects.indexOf("admin/devices/lost") > -1;
        const dashboardArea = event.urlAfterRedirects.indexOf("dashboard") > -1;
        const partnerArea =
          event.urlAfterRedirects.indexOf("admin/areas/partner") > -1;
        const clientArea =
          event.urlAfterRedirects.indexOf("admin/areas/client") > -1;
        const locationArea =
          event.urlAfterRedirects.indexOf("admin/areas/location") > -1;
        const areaArea =
          event.urlAfterRedirects.indexOf("admin/areas/area") > -1;
        const customFieldsArea =
          event.urlAfterRedirects.indexOf("settings/customfields") > -1;
        const typesArea =
          event.urlAfterRedirects.indexOf("settings/types") > -1;
        const contentArea =
          event.urlAfterRedirects.indexOf("medias/content") > -1;
        const scheduleCreateArea =
          event.urlAfterRedirects.indexOf("medias/schedule-single") > -1;
        const commandsArea =
          event.urlAfterRedirects.indexOf("settings/command") > -1;
        const playlistArea =
          event.urlAfterRedirects.indexOf("medias/playlist") > -1;

        if (analyticZone) {
          this.CurrentLogo = "assets/img/brand/analytics.png";
        } else if (digitalSineageZone || controlRoomZone) {
          this.CurrentLogo = "assets/img/brand/digitalsineage.png";
        } else {
          this.CurrentLogo = "assets/img/brand/logo.png";
        }
        this.SaveFilter = false;
        if (scheduleCreateArea) {
          this.SaveFilter = true;
        }
        if (
          userAreaList ||
          partnerArea ||
          dashboardArea ||
          deviceArea ||
          commandsArea ||
          userAreaSingle
        ) {
          this.showAreaSelector = false;
        } else {
          this.showAreaSelector = true;
          if (clientArea) {
            this.MaxLevel = 0;
          } else if (
            locationArea ||
            customFieldsArea ||
            playlistArea ||
            contentArea ||
            typesArea ||
            scheduleCreateArea
          ) {
            this.MaxLevel = 1;
          } else if (areaArea) {
            this.MaxLevel = 2;
          } else {
            this.MaxLevel = 3;
          }
        }

        if (analyticZone || (scheduleCreateArea && this.MaxLevel == 3)) {
          this.LoadAll = true;
        }

        if (
          event.urlAfterRedirects.indexOf("single") > -1 &&
          !scheduleCreateArea &&
          !userAreaSingle
        ) {
          this.Locked = true;
        } else {
          this.Locked = false;
        }
      });

    this.areaSubscription = this.areaSrv.CurrentChanged$.subscribe(
      (area: ICArea) => {
        this.createAreaBreads(area);
      },
    );
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.areaSubscription.unsubscribe();
  }
  onClick($event) {}

  onLogout() {
    this.areaSrv.clear().then((r) => {
      this.router.navigateByUrl("/");
    });
  }

  createAreaBreads(area: ICArea) {
    if (area == null) {
      return;
    }
    this.areaBreadcrumbs = area.Code;
    while (
      area.Fathers &&
      area.Fathers.length > 0 &&
      area.Fathers[0].Father &&
      area.Fathers[0].Father.Code
    ) {
      area = area.Fathers[0].Father;
      this.areaBreadcrumbs = area.Code + " / " + this.areaBreadcrumbs;
    }
  }

  translate(items: any[]) {
    let tCount = 0;
    items.forEach((e) => {
      if (e.name != undefined) {
        this.translateSrv.get(e.name).subscribe((r) => {
          tCount++;
          e.name = r;
          if (tCount == items.length) {
            this.translated = true;
          }
        });
      }
      if (e.children != undefined) {
        this.translate(e.children);
      }
    });
  }
}
